module.exports = __webpack_public_path__ + "static/screenshot4-aef6914029d91b763baaf11798bf0994.png";